export default __webpack_public_path__ + "static/media/attendance_out_screen.f0002ad2.gif";